export default "__VITE_ASSET__108270be__"